var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { staticClass: "class-card clickable" }, [
    _c("div", {
      staticClass: "card-cover-img-thumb",
      style: _vm.styleBindings,
      on: { click: _vm.goToClassReport }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "card-cover-text" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.cls.year) +
          " " +
          _vm._s(_vm.getShortenedString(_vm.cls.school_name, 10))
      ),
      _c("br"),
      _vm._v(
        "\n    " +
          _vm._s(_vm.cls.grade) +
          _vm._s(_vm.$t("card_details.card_meta.grade")) +
          " " +
          _vm._s(_vm.getShortenedString(_vm.cls.name, 15)) +
          _vm._s(_vm.$t("common.class")) +
          " | " +
          _vm._s(_vm.$t("common.student")) +
          " " +
          _vm._s(_vm.studentList.length) +
          _vm._s(_vm.$t("common.modal.preview.count\n")) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "clickable card-cover-bottom",
        on: { click: _vm.goToClassReport }
      },
      [
        _c("div", { staticClass: "class-card-asmt-cnt" }, [
          _vm._v(_vm._s(_vm.assignmentCount))
        ]),
        _vm._v("\n     " + _vm._s(_vm.$t("reports.assignment_count")) + "\n  ")
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d78fcbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d78fcbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/classes/components/ClassItem.vue
// module id = JX/M
// module chunks = 1